import { GlobalStyle, theme } from "@gsio/component-design-system";
import { lazy, type ReactNode, StrictMode, Suspense } from "react";
import { createRoot, type Root } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { CustomerApp } from "./CustomerApp";
import { BusinessEngineSurface } from "./styles/app-surface";
import { XyFlowStyles } from "./styles/xyflow";

const AdvancedApp = lazy(() =>
  import("./AppController").then((module) => ({ default: module.App })),
);
export function frontendRouteName(pathname: string): "customer" | "advanced" {
  if (pathname.startsWith("/advanced")) return "advanced";
  return "customer";
}

export function frontendRoute(pathname: string): ReactNode {
  switch (frontendRouteName(pathname)) {
    case "advanced":
      return <AdvancedApp />;
    default:
      return <CustomerApp />;
  }
}

export function mountBusinessEngineApp(
  rootElement: HTMLElement,
  hotData: { root?: Root },
  pathname = location.pathname,
) {
  const app = (
    <StrictMode>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <BusinessEngineSurface />
        <XyFlowStyles />
        <Suspense fallback={<div>Opening control panel…</div>}>
          {frontendRoute(pathname)}
        </Suspense>
      </ThemeProvider>
    </StrictMode>
  );
  if (hotData.root == null) hotData.root = createRoot(rootElement);
  hotData.root.render(app);
}
